<script setup lang="ts">
const { isErrorModalOpen, errorTitle, errorMessage } = useErrorModal();
</script>

<template>
  <UModal
    v-model:open="isErrorModalOpen"
    :title=errorTitle
    :ui="{
      footer: 'justify-end',
      title: 'font-normal text-error text-sm'
    }"
  >
    <template #body>
      <div class="text-muted text-sm">
        {{ errorMessage }}
      </div>
    </template>
  </UModal>
</template>
